// extracted by mini-css-extract-plugin
export default {"container":"RetailerGuard_container__Lr99O"};